import React from 'react';
import { Modal } from '@odin-labs/components';
import { PromptTimesIcon } from './PromptTimesIcon';

export type UnsavedChangesWarningModalProps = {
  open: boolean;
  isSaving?: boolean;
  onSaveChanges: () => void;
  onDiscardChanges: () => void;
  onCancel: () => void;
};

export function UnsavedChangesWarningModal(
  props: UnsavedChangesWarningModalProps,
): React.ReactElement {
  const { open, isSaving, onSaveChanges, onDiscardChanges, onCancel } = props;
  return (
    <Modal
      size="xs"
      open={open}
      setOpen={onCancel}
      title="You have unsaved changes"
      titleAlignment="center"
      text={
        'If you leave this page without saving, you will lose any \nchanges made since the last save.'
      }
      textAlignment="center"
      closeButtonBehavior="dismiss"
      cancelIcon={PromptTimesIcon}
      cancelText="Leave without saving"
      // Once its save has started there is no leaving without it.
      cancelButtonEnabled={!isSaving}
      onCancel={onDiscardChanges}
      actionText="Save Changes"
      actionButtonWithSpinner={isSaving}
      onAction={onSaveChanges}
    />
  );
}
